export const USER_ID = 'user';
export const CHATBOT_ID = 'chatbot';
export const SESSION_ID = 'session';
export const GLOBAL_ID = 'global';

export const USER_LABEL = 'Read Only';
export const CHATBOT_LABEL = 'Constants';
export const SESSION_LABEL = 'Read and Write';
export const GLOBAL_LABEL = 'Global';

const variablesDescription = {
  user: {
    id: USER_ID,
    label: USER_LABEL,
    editable: false,
  },
  chatbot: {
    id: CHATBOT_ID,
    label: CHATBOT_LABEL,
    editable: true,
  },
  session: {
    id: SESSION_ID,
    label: SESSION_LABEL,
    editable: true,
  },
  global: {
    id: GLOBAL_ID,
    label: GLOBAL_LABEL,
    editable: false,
  },
};

export default variablesDescription;
